import { SubPageLayout } from "@/components/SubPageLayout";
import { SITE_IMAGES } from "@/lib/site-data";

export default function TeraszTeliesites() {
  return (
    <SubPageLayout
      eyebrow="Terasz-téliesítés"
      title="Tegye négyévszakossá a teraszát."
      intro="Vendéglátóhelyek, kerthelyiségek és otthonok teraszainak teljes oldalfalas zárása vízhatlan PVC ponyvával – ablakos vagy ablak nélküli kivitelben. Szél, eső és hideg ellen."
      heroImage="/assets/gallery/terasz-telisites.jpg"
      bullets={[
        { title: "Ablakos oldal", text: "Átlátszó PVC ablakok természetes fényű, nyitott érzettel." },
        { title: "Cipzáras kivitel", text: "Részleges felhúzás, szellőztetés, könnyű karbantartás." },
        { title: "Egyedi méret", text: "Bármilyen terasz formára, oszlopos, korlátos vagy nyitott." },
        { title: "Téli szezon", text: "Akár 8–10 °C-kal magasabb hőmérséklet, fűthető tér." },
      ]}
      gallery={SITE_IMAGES.terraceWinterGallery}
    />
  );
}
